import { useDispatch, useSelector } from "react-redux";
import ColorizeIcon from "@mui/icons-material/Colorize";
import { IDetach } from "../../../models/interactions/Detach";
import Interaction from "../../../models/interactions/Interaction";
import NodeActorDropdown from "../components/NodeActorDropdown";
import NodeAttachPropDropdown from "../components/NodeAttachPropDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import {
  openSequencePositionPicker,
  selectSequencePositionPicker,
} from "../../../app/slices/GlobalSlice";
import { applyPickedPropToInteraction } from "./SequencePropPicker.helpers";
import { Prop } from "../../../models/Prop";
import {
  NODE_PICK_BUTTON_ACTIVE,
  NODE_PICK_BUTTON_BASE,
  NODE_PICK_BUTTON_IDLE,
} from "../components/nodeStyles";

export default function DetachNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const detach = props.interaction as IDetach;

  const { updateInteraction } = useUpdateSequenceInteraction();
  const dispatch = useDispatch();
  const sequencePositionPicker = useSelector(selectSequencePositionPicker);

  const isPickerActiveForNode =
    sequencePositionPicker.isOpen &&
    sequencePositionPicker.nodeId === props.nodeId &&
    sequencePositionPicker.positionType === "prop";

  const onChangePropDropdown = (prop: Prop) => {
    updateInteraction(props.nodeId, {
      ...applyPickedPropToInteraction(detach, prop),
    } as IDetach);
  };

  const actorDropdown = (
    <NodeActorDropdown
      label="Actor"
      selectedActorId={detach.playerGuid}
      onClick={(actorId: string) =>
        updateInteraction(props.nodeId, {
          ...detach,
          playerGuid: actorId,
        } as IDetach)
      }
    />
  );

  const propDropdown = (
    <NodeAttachPropDropdown
      selectedPropId={detach.propGuid}
      onChange={onChangePropDropdown}
      accessory={
        <button
          type="button"
          aria-label="Pick on map"
          title="Pick on map"
          data-testid="pick-prop-on-map-button"
          className={
            NODE_PICK_BUTTON_BASE +
            (isPickerActiveForNode
              ? NODE_PICK_BUTTON_ACTIVE
              : NODE_PICK_BUTTON_IDLE)
          }
          onClick={() =>
            dispatch(
              openSequencePositionPicker({
                nodeId: props.nodeId,
                positionType: "prop",
                title: "Pick prop",
                presentation: "splitView",
              }),
            )
          }
        >
          <ColorizeIcon fontSize="inherit" className="text-[18px]" />
        </button>
      }
    />
  );

  return (
    <div className="w-full h-full flex flex-col gap-[4px]">
      {propDropdown}
      {actorDropdown}
    </div>
  );
}
